import { IsArray, IsBoolean, IsNotEmpty, IsOptional, Length, ValidateNested } from 'class-validator';
import { CreateSurveyQuestionDto } from './create-survey-quetion.dto';
import { Type } from 'class-transformer';

export class UpdateSurveyTemplateDto {
	@IsNotEmpty()
	_id: string;

	@IsOptional()
	@IsBoolean()
	adminTemplate?: boolean;

	@IsNotEmpty()
	@Length(1)
	title: string;

	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateSurveyQuestionDto)
	questions?: Array<CreateSurveyQuestionDto>;

	districtIds: Array<string> | string;
	isDefaultTemplate?: boolean;
}
